(function($){
	$(document).ready(function(){
	
		if (jQuery(".resources-documents").length > 0){
			window.documentManager = new DocumentManager(".resources-documents");
			window.documentManager.initialize();
		}
		
		if (jQuery(".resources-photos").length > 0){
			window.photoManager = new PhotoManager(".resources-photos");
			window.photoManager.initialize();
		}
			
		var moreAnchor = $( '[id|="more"]' );
		if (moreAnchor.length >0){
			var expandText = '<a class="expand-text" href="javascript:void(0);">Lire la suite...</a>';
			var collapseText = '<a class="collapse-text" href="javascript:void(0);">Replier</a>';
			moreAnchor.html(expandText);
			$( '[id|=more] ~ p' ).slideUp();
			
			moreAnchor.parent().append(collapseText);
			$( 'a.collapse-text' ).hide().click(function(e){moreAnchor.trigger('click')});
			
			moreAnchor.click(function() {
				var $this = $(this);
				$( '[id|=more] ~ p' ).slideToggle( 400,
					function(){
						$this.toggleClass("open");
						
						if ($this.hasClass("open")) {
							$this.hide();
							$( 'a.collapse-text' ).show();
						} else {
						    $this.show();
						    $( 'a.collapse-text' ).hide();
						}
					}
				);
					
				
				});
			}
	});



	function DocumentManager(rootNode){
		
		this._rootNode = rootNode;
		this._order;
		this._currentPageIdx;
		this._lastPageLoaded;	
		
		this.initialize = function initialize(){
			this._currentPageIdx=1;
			jQuery(this._rootNode + " a.load-more-action").click({'manager':this}, this.loadDocuments);
			
		}
		
		this.loadDocuments =  function loadDocuments(e, manager){
			
			ajax_object.query.post_type = "attachment";
			if (!manager){manager = e.data.manager;}
			
			var data = {
				action: 'resources_get_documents',
				page: manager._currentPageIdx + 1,
				query: ajax_object.query,
				nonce: ajax_object.nonce_resources_get_resources, 
			};
			
			jQuery(".resources-loading").show();
			
			$.get({	url: ajax_object.ajaxurl,
					data: data, 
					context: manager,
					success: function(res) {
			
						if( res.success ){	
							this.addDocumentToList(res.data)
							this._currentPageIdx++;
							
							if (res.data['last_page']==true){
								this._lastPageLoaded=true;
								jQuery('.resources-documents-load-more').hide();
							}else{
								this._lastPageLoaded=false;
								jQuery('.resources-documents-load-more').show();
							}
							
							/*If curentPage is less or equal to 1 it means that first page have been loaded, so slideDown*/
							if(this._currentPageIdx<=1){
								jQuery('.resources-documents-section').slideDown();
							}						
						}
						
						jQuery(".resources-loading").hide();
						
						},
					error:function(xhr, textStatus, e) {
						jQuery(".resources-loading").hide();
						}
			});
		
		};
		
		this.resetLoad = function resetLoad(){
			var that = this;
			jQuery('.resources-documents-section').slideUp(400,
					function(){	that.removeDocuments();
								});
			this._currentPageIdx=0;		
			this._order = jQuery('.sort-actions-select').val();
			this._lastPageLoaded = false;
		};
		
	
		this.addDocumentToList = function (data){
			jQuery(".resources-documents-list .col").append(data);
		}
		
		
	};

	function PhotoManager(rootNode){
		
		this._rootNode = rootNode;
		
		this._displayType;
		this._currentPageIdx;
		this._lastPageLoaded;
		this._order;
		
		this.initialize = function(){
		
			this._currentPageIdx=1;
			
			/*Init sorting*/
			
			this._order = jQuery('.sort-actions-select').val();
			
			/*init grid load more button*/
			jQuery(this._rootNode + " a.load-more-action").click({'manager':this},this.loadPhotos);
			
			
			/* Init Slider */
			jQuery("#resources-photos-slider").slick( {
				centerMode: true,
				centerPadding: '0px',
				slidesToShow: 3,
				infinite: false,
				responsive: [
					{
				    breakpoint: 768,
				    settings: {
				    	arrows: false,
				        centerMode: true,
				        centerPadding: '40px',
					    slidesToShow: 3
				    	}
					},
					{
				 	breakpoint: 480,
				 	settings: {
				 		arrows: false,
				 		centerMode: true,
				 		centerPadding: '40px',
				        slidesToShow: 1
				      	}
				    }
					]
				});
			
			/* Init load more slider */
			jQuery("#resources-photos-slider").on("beforeChange",{'manager':this}, function(event, slick, currentSlide, nextSlide){
				var halfwaySlickSlideIdx = jQuery('.slick-slide:not(.slick-cloned)').length/2;
				if ( halfwaySlickSlideIdx  <= currentSlide){
					if (!event.data.manager._lastPageLoaded){
						event.data.manager.loadPhotos(event);
					}else{
						jQuery("#resources-photos-slider").off("beforeChange");
					}
				}
			});
			
			/* Init change of display*/
			jQuery(this._rootNode + " input[name='display_type']").change({'manager':this},this.changePhotoDisplayType);
			jQuery(this._rootNode + " input[name='display_type']:checked").trigger("change", [this]);
			
			jQuery('.sort-actions-select').change({'manager':this},function(e){e.data.manager.reLoadPhotos();});
			
			$('.resources-photos-grid').magnificPopup({
				  delegate: 'a', // child items selector, by clicking on it popup will open
				  type: 'image',
				  // other options
				  gallery: {
					  enabled: true, // set to true to enable gallery
	
					  preload: [1,3],
					  
					  navigateByImgClick: true,
	
					  arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>', // markup of an arrow button
	
					  tPrev: 'Previous (Left arrow key)', // title for left button
					  tNext: 'Next (Right arrow key)', // title for right button
					  tCounter: '<span class="mfp-counter">%curr% of %total%</span>' // markup of counter
					},
				
				callbacks: {
					updateStatus: function(data) {
					if(data.status =="ready"){
						var magnificPopup = $.magnificPopup.instance;
						if (magnificPopup.index + 2 == magnificPopup.items.length){
							window.photoManager.loadPhotos();
							}
						}
					}
									  
				  }
					
				});
			
			var observer = new MutationObserver(function(mutationsList){
				var magnificPopup = $.magnificPopup.instance;
				var nodes = mutationsList[0].addedNodes
				nodes.forEach(function(el) {
					var link = $(el).children('a');
					magnificPopup.items.push({src:link.prop('href'),title:link.prop('title') });
			    });			
				magnificPopup.updateItemHTML();					
				// Later, you can stop observing
				});
			var config = { attributes: true, childList: true, subtree: true };
			// Start observing the target node for configured mutations
			observer.observe($(".resources-photos-grid")[0], config); 
	
	//		jQuery(document).on('click', '[data-toggle="lightbox"]', function(event) {
	//            event.preventDefault();
	//            $(this).ekkoLightbox({
	//	            onContentLoaded:function(){
	//	            	if (this._galleryIndex + 2 == this._$galleryItems.length){
	//	            		
	//	            		var lb = this;
	//	            		
	//						var config = { attributes: true, childList: true, subtree: true };
	//						var observer = new MutationObserver(function(){
	//							lb.updateNavigation();
	//							
	//							// Later, you can stop observing
	//							observer.disconnect();
	//							
	//						});						
	//						// Start observing the target node for configured mutations
	//						observer.observe($(".resources-photos-grid")[0], config);
	//						
	//						 
	//						window.photoManager.loadPhotos();
	//				         }
	//	            	}
	//			});
	//        });
			
			/*Init search keyword */
			jQuery('.search-actions-button').click({'manager':this},function(e){e.data.manager.reLoadPhotos();});
			jQuery('.search-clear-actions-button').click({'manager':this},function(e){jQuery(".search-actions-input").val('');e.data.manager.reLoadPhotos();});
			jQuery('.search-clear-actions-button').hide();
		}
		
		this.resetLoad = function(){
			this.removePhotosFromGrid();
			this.removePhotosFromSlider();
			this._currentPageIdx=0;		
			this._order = jQuery('.sort-actions-select').val();
			this._lastPageLoaded = false;
		}
		
		this.reLoadPhotos = function(){
			var that = this;
			jQuery('.resources-photos-section').slideUp(400,
					function()
					{
						that.resetLoad();
						that.loadPhotos();
					});
			
		}
		
		this.changePhotoDisplayType = function(e, manager){
			e.preventDefault();
			var newDisplayType = jQuery(e.target).val();
			if (!manager){manager=e.data.manager;}
			if (manager._displayType != newDisplayType){
				switch(newDisplayType){
					case "grid":
						{
						jQuery('.resources-photos-grid-row').fadeIn();
						jQuery('.resources-photos-slider-row').fadeOut();
						
						break;
						}
					case "slider":
					{
						jQuery('.resources-photos-grid-row').fadeOut();
						jQuery('.resources-photos-slider-row').fadeIn(400,function(){
							jQuery("#resources-photos-slider").slick('refresh');
						});					
						break;
					}
					default:{
						
					}
				}
				manager._displayType = newDisplayType;
			}
			
		}
		
		this.loadPhotos =  function(e, manager){
			
			ajax_object.query.post_type = "attachment";
			
			if (e){
				if (!manager){manager=e.data.manager;}
			}else{
				manager = this;
			}
			
			var data = {
				action: 'resources_get_photos',
				page: manager._currentPageIdx + 1,
				order: manager._order,
				query: ajax_object.query,
				nonce: ajax_object.nonce_resources_get_resources, 
			};
			
			/*handle search keyword*/
			if (jQuery(".search-actions-input").val()!=''){
				data['s']=jQuery(".search-actions-input").val();
				jQuery('.search-clear-actions-button').show();
			}else{
				jQuery('.search-clear-actions-button').hide();
			}
			
			jQuery(".resources-loading").show();
			
			$.get({	url:ajax_object.ajaxurl, 
					data:data,
					context: manager,
					success: function(res) {
			
						if( res.success ){
							this.addPhotosToGrid(res.data['grid']);
							this.addPhotosToSlider(res.data['slide']);
	
							if (res.data['last_page']==true){
								this._lastPageLoaded=true;
								jQuery('.resources-photos-load-more').hide();
							}else{
								this._lastPageLoaded=false;
								jQuery('.resources-photos-load-more').show();
							}
							this._currentPageIdx++;
							/*If curentPage is less or equal to 1 it means that first page have been loaded, so slideDown*/
							if(this._currentPageIdx<=1){
								jQuery('.resources-photos-section').slideDown();
								jQuery("#resources-photos-slider").slick('refresh');
							}
						}
						jQuery(".resources-loading").hide();
						
					},
					error: function(xhr, textStatus, e) {
						// console.log(xhr.responseText);
						jQuery(".resources-loading").hide();
						}
					});
				
		};
		
		this.addPhotosToGrid = function (data){
			jQuery(".resources-photos-grid").append(data);
			
		}
		this.removePhotosFromGrid = function(){
			jQuery(".resources-photos-grid").empty();
		}
		
		this.addPhotosToSlider = function (data){
			for( var partIdx in data){
				/*TVI 2019-01-29 Slick bug fix: add div node to avoid display issues*/
				jQuery("#resources-photos-slider").slick('slickAdd',"<div><div>"+ data[partIdx] +"</div></div>");
			}
		}
		
		this.removePhotosFromSlider = function (){
			var slideNb = jQuery('.slick-slide:not(.slick-cloned)').length;
			for( var slideIdx=0 ; slideIdx<slideNb; slideIdx++){
				jQuery("#resources-photos-slider").slick('slickRemove',null,false);
			}
		}
	};

}(jQuery));